var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ToDo",style:(_vm.styles)},[(_vm.name)?_c('WText',{staticClass:"Name",attrs:{"size":"14","weight":"bold"}},[_vm._v(" "+_vm._s(_vm.name)+" ")]):_vm._e(),(_vm.description)?_c('WText',{staticClass:"Description",attrs:{"size":"14","weight":"light"}},[_vm._v(" "+_vm._s(_vm.description)+" ")]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }